// ds-allow-raw-color: マスクの白黒は色ではなくチャンネル値 (白=残す / 黒=抜く)。
// テーマに追従させるとマスクが効かなくなる。
const MASK_KEEP = "white";
// ds-allow-raw-color: マスクの黒も同じくチャンネル値であり、テーマ色に置き換えられない。
const MASK_CUT = "black";

export { MASK_CUT, MASK_KEEP };
